import type { Row } from 'read-excel-file';
import { DateTime } from 'luxon';

const partyUidRegexp = /^[a-zA-Z0-9]+-[a-zA-Z0-9]+-[a-zA-Z0-9]+-[a-zA-Z0-9]+-[a-zA-Z0-9]+$/;
const isPartyUid = (value: unknown): value is string => {
  return typeof value === 'string' && partyUidRegexp.test(value);
};

const isDate = (value: unknown): value is Date => {
  return value instanceof Date;
};

const notNullish = <T>(value: T | null | undefined): value is T =>
  value !== null && value !== undefined;

// The type from read-excel-file seems to be wrong, it uses 'typeof Date' instead of 'Date'
type CorrectedRowType = Array<Row[number] | Date>;

/**
 * Extract participants (partyUid and entryDate) from a sheet
 *
 * Scan all cells in each row for a string looking like a partyUid and a date.
 */
export const sheetToParticipants = (sheet: Array<CorrectedRowType>) => {
  const participants = sheet
    .map((row) => {
      const partyUid = row.find(isPartyUid);
      const entryDate = row.find(isDate);
      if (partyUid && entryDate) {
        return {
          partyUid,
          entryDate: DateTime.fromJSDate(entryDate).toISODate(),
        };
      }
      return null;
    })
    .filter(notNullish);

  return participants;
};
